import GenericNewCategoryPage from './GenericNewCategoryPage';

function Empowerment() {
  return <GenericNewCategoryPage categoryId={13} categoryKey="empowerment" />;
}

export default Empowerment;
